import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import './ModalBase.styl';

if (typeof window !== 'undefined') {
    Modal.setAppElement('#___gatsby');
}

const customStyles = {
    Modal: {},
    content: {
        borderRadius: 20,
        bottom: 'auto',
        left: '50%',
        marginRight: '-50%',
        maxWidth: '75%',
        padding: 60,
        right: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 100,
    },
};

const ModalBase = ({ children, closeModal, modalIsOpen }) => (
    <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => closeModal()}
        style={customStyles}
        contentLabel='Example Modal'
    >
        <div className='modal-base'>{children}</div>
    </Modal>
);

ModalBase.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    modalIsOpen: PropTypes.bool.isRequired,
};

export default ModalBase;
